import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Alert,Row, Col, Button, Input, Form, FormGroup, Label } from "reactstrap";

const API_URL = process.env.REACT_APP_API_URL_BASE;

function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
  const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\s]|(?<=\s).*(?=\s)).{8,}$/;
  return re.test(password);
}

const ForgotPassword_step1 = props => {
  const [email, setEmail] = useState('');
  const [otp, setOTP] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState(null);
  const [success, setSuccess] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [resetRequired, setResetRequired] = useState(false);
  const [showOtpSuccessMsg, setShowOtpSuccessMsg] = useState(false);
  const [showResetRequiredMsg, setShowResetRequiredMsg] = useState(false);
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);

  useEffect(() => {
    if(props.resetRequired) {
      setResetRequired(true);
      setShowResetRequiredMsg(true);
    }
  }, [props]);

  const submit = (event) => {
    setErrorText("");
    setError(false);
    setSuccess(false);
    setShowOtpSuccessMsg(false);
    setShowResetRequiredMsg(false);

    event.preventDefault();
  
    let errors = [];

    if (email.length === 0) {
      errors.push('Email is required.');
    } else if (!validateEmail(email)) {
      errors.push('Please type valid email.');
    }

    if ((otpSent || resetRequired) && !validatePassword(newPassword)) {
      errors.push('Password must be at least 8 characters with 1 number, 1 lowercase, 1 uppercase, and 1 special character');
    }

    if (errors.length > 0) {
      setError(true);
      setErrorText(errors.join('\n'));
      return false;
    }

    let payload = {};
    
    let endpoint = "forgot-password";

    if(otpSent || resetRequired) {
      endpoint += "/confirm"
      payload = {
        "email": email,
        "otp": otp,
        "new_password": newPassword,
      }
    }
    else {
      payload = {
        "email": email,
      }
    }

    axios.post(`${API_URL}users/${endpoint}`, payload)
    .then(function (r) {
      if (r.status === 201 || r.status === 200) {
        setSuccess(true);
        if(!otpSent && !resetRequired) {
          setOtpSent(true);
          setShowOtpSuccessMsg(true);
        } else {
          setPasswordResetSuccess(true);
        }
      } else {
        setError(true);
      }

    }).catch(function (error) {
    if (error.response) {
      if(error.response.status === 400 || error.response.status === 404 || error.response.status === 409 || error.response.status === 429)
      {
        let error_data = error.response.data;
        let error_msg = error_data.detail;

        if(error_msg) {
          setError(true);
          setErrorText(error_msg);
        }
        else
        {
          setError(true);
          setErrorText('Something went wrong. Please try again.');
          
        }
      }
      else {
        setError(true);
        setErrorText('Something went wrong. Please try again.');
      }
    } else if (error.request) {
      setError(true);
      setErrorText('Something went wrong. Please try again.');
    } else {
      setError(true);
      setErrorText('Something went wrong. Please try again.');
    }
    });
  }

  return (
    <Row className="no-gutters justify-content-center">
					<Col md="6" lg="4" className="bg-primary text-white">
						<div className="p-4">
							<h1 className="display-5">Hi,<br />
							<span className="text-cyan font-bold ">let's send some loud music out there</span></h1>

						</div>
					</Col>
					<Col md="6" lg="4" className="bg-white">
						<div className="p-4">
							<h3 className="font-medium mb-3">Recover Password</h3>
							<Form>

                {
                  (!otpSent || resetRequired) && <FormGroup>
                    <Label for="email">Your email</Label>
                    <Input type="email" name="email" id="email" placeholder="Type your email..." value={email} onChange={(e) => setEmail(e.target.value)}/>
                  </FormGroup>
                }

                {
                  (otpSent || resetRequired) && <>
                    <FormGroup>
                      <Label for="otp">OTP</Label>
                      <Input type="text" name="otp" id="otp" placeholder="Type OTP code sent to your email.." disabled={passwordResetSuccess} value={otp} onChange={(e) => setOTP(e.target.value)}/>
                    </FormGroup>

                    <FormGroup>
                      <Label for="otp">New Password</Label>
                      <Input type="password" name="new_password" id="new_password" placeholder="Type New Password" disabled={passwordResetSuccess} value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
                    </FormGroup>
                  </>
                }

                <Row className="mb-3">
                  <Col xs="12">
                  <Button size="lg" color="success" type="submit" block disabled={passwordResetSuccess} onClick={(event) =>submit(event)}>Submit</Button>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs="12">
                    <Button size="lg" color="primary" type="submit" block onClick={() =>props.handleToLogin()}>Back to login</Button>
                  </Col>
                </Row>

                <Row>
                  <Col xs="12">
                  { (resetRequired && showResetRequiredMsg) &&
                    <Alert color="success">Password Reset is Required for your account, Please check your email for OTP!</Alert>
                  }
                  { (otpSent && showOtpSuccessMsg) &&
                    <Alert color="success">Please check your email for OTP!</Alert>
                  }
                  {
                    (error && errorText) &&
                    <Alert color="danger">{errorText}</Alert>
                  }
                  {
                    (error && !errorText) && 
                    <Alert color="danger">Something went wrong</Alert>
                  }
                  {
                    passwordResetSuccess && 
                    <Alert color="success">Your password has been reset Successfully.</Alert>
                  }
                  </Col>
                </Row>
              </Form>
						</div>
					</Col>
				</Row>
  )

};

export default ForgotPassword_step1;
